<template>
  <div class="wrapper" style="height:400px;width:100%;">
    <div class="row">
      <div class="col-md">
        <div role="toolbar" class="btn-toolbar justify-content-between mb-2">
          <button @click="save()" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
          <div class="input-group ml-3">
            <input type="text" placeholder="Auftrags-Nr" class="form-control" v-model="testid"/>
            <div class="input-group-append">
              <button @click="testRule" class="btn btn-secondary"><font-awesome-icon icon="vial"/></button>
            </div>
          </div>
        </div>
        <AceEditor ref="editor" :editorId='"orderCheckEdit"' :lang="'javascript'" :content="script"/>
      </div>
      <div class="col-md">
        <iframe style="width:100%;height:500px;border: none;" :src="baseurl + 'help/scriptrules/orderprework.html'">
        </iframe>
      </div>
    </div>
    <b-modal id="orderCheckResult" size="xl" title="Test-Ergebniss" ok-only>
      <JsonViewer :data="testresult"/>
    </b-modal>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import rules from '@/modules/rules.js'
import AceEditor from '@/components/AceEditor.vue'
import JsonViewer from '@/components/JsonViewer.vue'

export default {
  name: 'RuleOrderCheck',
  components: {
    AceEditor,
    JsonViewer,
  },
  data() {
    return {
      baseurl: config.baseUrl,
      script: "",
      testid: '',
      testresult: {},
    }
  },
  created: function() {
    var self = this;
    rules.load('orderPreWork',function(data) {
      if (data) self.script = data.script;
    });
  },
  methods: {
    testRule: function() {
      console.log('test');
      if (this.testid == '')  {
        this.$bvToast.toast('Bitte zuerst eine Auftragsnummer als Beispiel eingeben.',{title:'Auftragsprüfung',variant:'warning'})
        return;
      }
      var self = this;
      rules.testordercheck(this,this.testid,{script: this.$refs.editor.getContent()},function(data){
        console.log(data);
        self.testresult = data;
        self.$bvModal.show('orderCheckResult');
      })
    },
    save: function() {
      this.script = this.$refs.editor.getContent();
      var update = {ruleId: 'orderPreWork',script: this.script};
      var self = this;
      rules.save(update,function() {
        self.$bvToast.toast(`Regel gespeichert`, { title: 'Auftragsprüfung', autoHideDelay: 2000, appendToast: true, variant:'success' })
      });
    }
  }
}
</script>
